<template>

<div class="foot">

	<div class="foot-share" v-if="share">Know someone who'd appreciate this information? <span role="button" tabindex="0" v-on:click="$emit('mailto', shareURL)" v-on:keyup.enter="$emit('mailto', shareURL)">SHARE IT!</span></div>

	<div class="foot-link">In partnership with <a href="https://www.recyclebycity.com" target="_blank">Recycle by City</a></div>

	<div class="foot-legal">
		<a href="https://www.iubenda.com/privacy-policy/81735639" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Privacy Policy ">Privacy Policy</a>
		<a href="https://www.iubenda.com/privacy-policy/81735639/cookie-policy" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Cookie Policy ">Cookie Policy</a>
		<a href="https://www.iubenda.com/terms-and-conditions/81735639" class="iubenda-white iubenda-noiframe iubenda-embed iubenda-noiframe " title="Terms and Conditions ">Terms and Conditions</a>
	</div>

</div>

</template>

<script>

import { initIubendaEmbeds } from '@/utils/iubenda'

export default {

	props: ['share'],

	mounted: function() {

		initIubendaEmbeds()

	},

	updated: function() {

		initIubendaEmbeds()

	},

	computed: {

		shareURL: function() {

			return (this.share) ? 'mailto:?subject=' + encodeURIComponent(this.share.subject) + '&body=' + encodeURIComponent(this.share.body) : false

		}

	}

}

</script>

<style scoped>

.foot {
	height: auto;
	background-color: #e3e3e3;
	padding: 20px;
	margin-top: -5px;
	display: flex;
	flex-direction: column;
	align-items: center;
	border-radius: 0px 0px 12px 12px;
}

.foot-share {
	font-size: 20px;
	font-weight: bold;
	line-height: 24px;
	text-align: center;
	color: #333;
	padding-bottom: 20px;
}

.foot-share span {
	color: #007db8;
	cursor: pointer;
}

.foot-share span:hover {
	text-decoration: underline;
}

.foot-link {
	font-size: 16px;
	font-weight: bold;
	text-align: center;
	color: #333;
	padding-bottom: 20px;
}

.foot-link a {
	color: #007db8;
}

.foot-link a:hover {
	text-decoration: underline;
}

</style>
